// extracted by mini-css-extract-plugin
module.exports = {"mark":"PlanSectionMark_mark__2UYJX","content":"PlanSectionMark_content__1Wx5v","title":"PlanSectionMark_title__oWfXN"};